/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralAiResponseDto } from '../../models/general-ai-response-dto';
import { RequestDataBasedGenerationDto } from '../../models/request-data-based-generation-dto';

export interface DocumentAiControllerAiDataBasedGeneration$Params {
      body: RequestDataBasedGenerationDto
}

export function documentAiControllerAiDataBasedGeneration(http: HttpClient, rootUrl: string, params: DocumentAiControllerAiDataBasedGeneration$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerAiDataBasedGeneration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralAiResponseDto>;
    })
  );
}

documentAiControllerAiDataBasedGeneration.PATH = '/api/document-ai/ai-data-based-generation';
